import type * as React from "react";
export const CrossIcon = (props: React.SVGProps<SVGSVGElement>) => {
	return (
		<svg
			width={17}
			height={16}
			viewBox="0 0 17 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M16.0231 0.781614L1.58631 15.2184M1.58631 0.781614L16.0231 15.2184"
				stroke="currentColor"
				strokeWidth={1.5}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
